<div class="ack-template">
  <h3>CUSTOMER ORDER ACKNOWLEDGMENT</h3>
  <p class="hint">
    Previously signed acknowledgments keep the exact language the customer signed. Changing this template does not rewrite old invoices.
  </p>
  <mat-form-field style="width:100%">
    <mat-label>NAME</mat-label>
    <input matInput [(ngModel)]="template.name" autocomplete="off">
  </mat-form-field>
  <mat-form-field style="width:100%">
    <mat-label>LANGUAGE</mat-label>
    <textarea matInput rows="10" [(ngModel)]="template.body"></textarea>
  </mat-form-field>
  <p class="hint" *ngIf="template.version">Version {{ template.version }}</p>
  <button mat-raised-button color="primary" type="button" [disabled]="saving" (click)="save()">SAVE</button>
</div>
